import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import HomePage from "./pages/HomePage"
import SingleArticlePage from "./pages/SingleArticlePage"
import PortalArticlePage from "./pages/PortalArticlePage"
import { ModalProvider } from "./helpers/modalContext"
import { UserProvider } from "./helpers/userContext"
import CategoryArticle from "./pages/CategoryArticlePage"
import AuthModal from "./helpers/authModal"
import SearchResultsPage from "./pages/SearchResultPage"
import ProfilePage from "./pages/ProfilePage"
import NotFoundPage from "./pages/NotFoundPage"
import DefaultLayout from "./layouts/DefaultLayout"
import NoHeaderLayout from "./layouts/NoHeaderLayout"
import ProtectedRoute from "./helpers/ProtectedRoute"
import ErrorBoundary from "./components/ErrorBoundary"
import { RouteErrorWrapper } from "./components/RouteWrappers"
import PortalPage from "./pages/PortalPage"
import VideosPage from "./pages/VideosPage"
import PublicationDetailPage from "./pages/PublicationDetailPage"
import TermsAndConditions from "./pages/TermsAndConditions"
import PrivacyPolicy from "./pages/PrivacyPolicy"
import AnalyticsTracker from "./components/AnalyticsTracker"

function App() {
  return (
    <ErrorBoundary>
      <Router basename="/">
        <AnalyticsTracker />
        <UserProvider>
          <ModalProvider>
            <AuthModal />
            <Routes>
              <Route
                path="/"
                element={
                  <DefaultLayout>
                    <HomePage />
                  </DefaultLayout>
                }
              />
              <Route
                path="/search"
                element={
                  <DefaultLayout>
                    <SearchResultsPage />
                  </DefaultLayout>
                }
              />
              <Route
                path="/profile"
                element={
                  <DefaultLayout>
                    <ProtectedRoute>
                      <ProfilePage />
                    </ProtectedRoute>
                  </DefaultLayout>
                }
              />
              <Route
                path="/terms-and-conditions"
                element={
                  <DefaultLayout>
                    <TermsAndConditions />
                  </DefaultLayout>
                }
              />
              <Route
                path="/privacy-policy"
                element={
                  <DefaultLayout>
                    <PrivacyPolicy />
                  </DefaultLayout>
                }
              />
              
              <Route
                path="/portal"
                element={
                  <DefaultLayout>
                    <RouteErrorWrapper>
                      <PortalPage />
                    </RouteErrorWrapper>
                  </DefaultLayout>
                }
              />
                <Route
                path="/videos"
                element={
                  <DefaultLayout>
                    <RouteErrorWrapper>
                      <VideosPage />
                    </RouteErrorWrapper>
                  </DefaultLayout>
                }
              />

              {/* Parameterized routes with validation */}
              <Route
                path="/article/:id"
                element={
                  <DefaultLayout>
                    <RouteErrorWrapper>
                      <SingleArticlePage />
                    </RouteErrorWrapper>
                  </DefaultLayout>
                }
              />
              <Route
                path="/portal/:portalName"
                element={
                  <DefaultLayout>
                    <RouteErrorWrapper>
                      <PortalArticlePage />
                    </RouteErrorWrapper>
                  </DefaultLayout>
                }
              />
              
              {/* Category route with validation */}
              <Route
                path="/category/:categoryName"
                element={
                  <DefaultLayout>
                    <RouteErrorWrapper>
                      <CategoryArticle />
                    </RouteErrorWrapper>
                  </DefaultLayout>
                }
              />

              {/* Publication route with validation */}
              <Route
                path="/publication/:publicationId"
                element={
                  <DefaultLayout>
                    <RouteErrorWrapper>
                      <PublicationDetailPage />
                    </RouteErrorWrapper>
                  </DefaultLayout>
                }
              />

              {/* 404 catch-all route */}
              <Route
                path="*"
                element={
                  <NoHeaderLayout>
                    <NotFoundPage />
                  </NoHeaderLayout>
                }
              />
            </Routes>
          </ModalProvider>
        </UserProvider>
      </Router>
    </ErrorBoundary>
  )
}

export default App
